'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Flowout = require('./Flowout');

var _Flowout2 = _interopRequireDefault(_Flowout);

var _FlowoutController = require('./FlowoutController');

var _FlowoutController2 = _interopRequireDefault(_FlowoutController);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopUpMenu = function (_React$PureComponent) {
  (0, _inherits3.default)(PopUpMenu, _React$PureComponent);

  function PopUpMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopUpMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopUpMenu.__proto__ || (0, _getPrototypeOf2.default)(PopUpMenu)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      var _this$props = _this.props,
          controllerIcon = _this$props.controllerIcon,
          children = _this$props.children,
          shown = _this$props.shown,
          toggleFlowOut = _this$props.toggleFlowOut,
          renderMenuHeader = _this$props.renderMenuHeader,
          direction = _this$props.direction;


      return React.createElement(
        'div',
        { className: (0, _classnames2.default)('pop-up-menu', 'pop-up-menu--' + direction) },
        React.createElement(_FlowoutController2.default, {
          toggleFlowOut: toggleFlowOut,
          iconName: controllerIcon }),
        React.createElement(
          _Flowout2.default,
          {
            shown: shown,
            toggleFlowOut: toggleFlowOut,
            direction: direction,
            renderMenuHeader: renderMenuHeader },
          children
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return PopUpMenu;
}(React.PureComponent);

PopUpMenu.defaultProps = {
  shown: false,
  direction: 'left'
};
exports.default = PopUpMenu;